import React from "react";
import { Label, FormGroup } from "components/formElements";
import DatePicker from "react-datepicker";
import styles from "./CustomDatePicker.module.scss";
import PropTypes from "prop-types";
import { getDateNYearsAgo } from "../../../util/library";
import { FaExclamationCircle } from "react-icons/fa";

const CustomDatePicker = ({
  label,
  id,
  required,
  dateError,
  errorMessage,
  openToDateYearRange,
  minDateYearRange,
  maxDateYearRange,
  ...rest
}) => (
  <FormGroup className={styles.datePickerContainer}>
    <DatePicker
      id={id}
      className={`${styles.datePicker} ${dateError ? styles.dateError : ""}`}
      showMonthDropdown
      useShortMonthInDropdown
      showYearDropdown
      dropdownMode="select"
      openToDate={openToDateYearRange}
      minDate={minDateYearRange}
      maxDate={maxDateYearRange}
      //placeholderText="Click to select a date"
      required={required}
      dateFormat="dd/MM/yyyy"
      autoComplete="off"
      {...rest}
    />
    {/* dummy input to style label */}
    {required && <input className={styles.hiddenInput} />}
    <Label
      htmlFor={id}
      label={label}
      className={`${dateError ? styles.errorLabel : ""}`}
      value={rest.selected}
    />
    <FaExclamationCircle
      className={`${styles.errorSymbol} ${dateError ? styles.showError : ""}`}
    />
    <span className={styles.errorMessage}>{errorMessage}</span>
  </FormGroup>
);

CustomDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  dateError: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
};

export { CustomDatePicker };
